module.exports = __webpack_public_path__ + "static/media/file-medical-alt.c992580b.svg";